import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../commons/Footer';
import Header from '../commons/Header';

const Layout = () => {
  return (
    <div>
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Layout;
